import * as React from 'react';

import { useTheme } from '@coursera/cds-core';

import Skills from 'bundles/unified-career-academy/components/Skills';

type Props = {
  valueProps?: (string | null | undefined)[] | null;
};

const RolePageHeroValueProps = ({ valueProps }: Props) => {
  const theme = useTheme();
  return (
    <Skills
      skills={valueProps}
      variant="status"
      // inline style is used to override CDS styles
      style={{
        backgroundColor: 'var(--cds-color-blue-950)',
        border: 'none',
      }}
    />
  );
};

export default RolePageHeroValueProps;
